<template>
  <v-main>
    <v-container fill-height fluid>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <v-card class="elevation-12">
            <ValidationObserver ref="form" v-slot="{ passes }">
              <v-card-title>
                <h3>{{ $t("language." + $store.getters.pagetitle) }}</h3>
              </v-card-title>
              <v-card-text>
                <v-form>
                  <ValidationProvider
                    :name="$t('language.password')"
                    rules="required"
                    v-slot="{ errors }"
                    vid="password"
                  >
                    <v-text-field
                      v-model="password"
                      :label="$t('language.password')"
                      :error-messages="errors[0]"
                      :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                      :type="showPassword ? 'text' : 'password'"
                      prepend-icon="mdi-lock"
                      @click:append="showPassword = !showPassword"
                    />
                  </ValidationProvider>
                  <ValidationProvider
                    :name="$t('language.confirmpassword')"
                    rules="confirmed:password"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="confirmpassword"
                      :label="$t('language.confirmpassword')"
                      :error-messages="errors[0]"
                      :append-icon="
                        showConfirmPassword ? 'mdi-eye-off' : 'mdi-eye'
                      "
                      :type="showConfirmPassword ? 'text' : 'password'"
                      prepend-icon="mdi-lock"
                      @keydown.enter="passes(submit)"
                      @click:append="showConfirmPassword = !showConfirmPassword"
                    />
                  </ValidationProvider>
                </v-form>
              </v-card-text>

              <v-card-actions>
                <v-btn
                  align-center
                  justify-center
                  color="general"
                  @click="passes(submit)"
                  >{{ $t("language.submit") }}</v-btn
                >
                <v-spacer />
                <router-link to="/login" class="tertiary--text">{{
                  $t("language.login")
                }}</router-link>
              </v-card-actions>
            </ValidationObserver>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  data: function() {
    return {
      password: null,
      confirmpassword: null,
      showPassword: false,
      showConfirmPassword: false,
      processing: false,
    };
  },
  methods: {
    submit: function() {
      if (this.processing) return;
      this.processing = true;
      axios
        .post("/account/resetpassword", {
          password: this.password,
          activationcode: this.$route.query.code,
        })
        .then((response) => {
          this.password = null;
          this.confirmpassword = null;
          this.processing = false;
          this.$store.dispatch(
            "setMessage",
            this.$t("language.passwordsetsuccessful")
          ).then(() => this.$router.push("/success"));
          
          // this.$nextTick(() => {
          //   this.$refs.form.reset();
          // });
        })
        .catch((err) => {
          this.processing = false;
        });
    },
  },
  metaInfo() {
    return {
      title: this.$store.getters.applicationtitle + " | Set Password",
    };
  },
};
</script>
